<template>
  <div class="c-notfound text-center">
    <v-row>
      <v-col>
        <h3>I am extremely disappointed, this route does not exist!</h3>

        Redirection in 5 seconds
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'NotFound',

  mounted () {
    setTimeout(() => {
      this.$router.push({ name: 'home' });
    }, 5000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
